import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class Tempete extends PIXI.Container {

  constructor() {
    super();

    this.shown = false;
    this.sound = null;
    this.soundPlaying = false;
    this.soundVolume = {value: 0};
    this.fadeDuration = 5;
    this.audioFadeDuration = 2; // sec

    this.build();
  }

  build() {
    this.sound = new Howl({
      src: [app.data.global.sounds.wind_storm],
      loop: true,
      autoplay: false,
      volume: 0,
    });

    // We'll set the height of these sections later
    this.topWhite = new PIXI.Graphics().rect(0, 0, app.game.appWidth, app.game.appHeight).fill(0xFFFFFF);
    this.topWhite.pivot.set(0, app.game.appHeight);

    this.sprite = new PIXI.Sprite(app.game.assets["tempete"]);
    this.sprite.anchor.set(0, 1);
    this.sprite.texture.source.resource.loop = true;

    this.bottomWhite = new PIXI.Graphics().rect(0, 0, app.game.appWidth, app.game.appHeight).fill(0xFFFFFF);

    this.addChild(this.topWhite, this.sprite, this.bottomWhite);

    this.alpha = 0;

    this.pauseVideo();
    // this.stop();
  }

  setPosition(startY = 0) {
    this.topWhite.position.y = startY - this.sprite.height; // add to overlap correctly
    this.sprite.position.y = startY;
    this.bottomWhite.position.y = startY; // minus to overlap correctly
  }

  endOfTurnAction() {

    if (!this.shown && (app.game.player.currentTile.rowIndex <= app.game.currentGameTemplate.tempete.start) && (app.game.player.currentTile.rowIndex > app.game.currentGameTemplate.tempete.end)) {
      this.start();
    } else if (this.shown && app.game.player.currentTile.rowIndex <= app.game.currentGameTemplate.tempete.end) {
      this.stop();
    }
  }

  start(audioFadeIn = true) {
    this.shown = true;
    this.playVideo();

    gsap.to(this, {
      pixi: {
        alpha: 1
      },
      duration: this.fadeDuration,
      ease: "power1.inOut",
    })

    this.playAudio(audioFadeIn);
  }

  stop(audioFadeOut = true) {
    this.shown = false;

    this.stopAudio(audioFadeOut);

    gsap.to(this, {
      pixi: {
        alpha: 0
      },
      duration: this.fadeDuration,
      ease: "power1.inOut",
    })
  }

  playAudio(fadeIn = true) {

    if (!this.soundPlaying) {
      this.soundPlaying = true;

      if (fadeIn) {
        this.sound.play();

        gsap.to(this.soundVolume, {
          value: 1,
          duration: this.audioFadeDuration,
          ease: "quad.in",
          overwrite: "auto",
          onUpdate: () => {
            this.sound.volume(this.soundVolume.value);
          },
          onComplete: () => {
          }
        })
      } else {
        this.sound.play();
        this.sound.volume(1);
      }
    }

  }

  stopAudio(fadeOut = true) {
    if (this.soundPlaying) {
      if (fadeOut) {
        gsap.to(this.soundVolume, {
          value: 0,
          duration: this.audioFadeDuration,
          ease: "quad.in",
          overwrite: "auto",
          onUpdate: () => {
            try {
              this.sound.volume(this.soundVolume.value);
            } catch (e) {

            }
          },
          onComplete: () => {
            this.soundPlaying = false;
            this.pauseVideo();
          }
        })
      } else {
        this.soundVolume.value = 0;
        this.sound.volume(0).stop().seek(0);
        this.pauseVideo();
      }
    }
  }

  playVideo(){
    this.sprite.texture.source.resource.play();
  }

  pauseVideo(){
    this.sprite.texture.source.resource.pause();
  }

  reset() {
    if (this.shown || this.soundPlaying) {
      this.stop();
    }
  }


}
